module.exports = __webpack_public_path__ + "static/media/retail-geotiller.58e27092.svg";